import cx from 'classnames'
import PropTypes from 'prop-types'

const CustomSpinnerBasicLoader = ({inheritColorText, loader, text}) => {
  const classNameText = cx('mt-SpinnerBasic-text', {
    'mt-SpinnerBasic-text--inheritColorText': inheritColorText
  })
  return (
    <>
      {loader}
      {Boolean(text) && <div className={classNameText}>{text}</div>}
    </>
  )
}

CustomSpinnerBasicLoader.displayName = 'CustomSpinnerBasicLoader'
CustomSpinnerBasicLoader.propTypes = {
  inheritColorText: PropTypes.bool,
  loader: PropTypes.elementType.isRequired,
  text: PropTypes.text
}

export default CustomSpinnerBasicLoader
